// extracted by mini-css-extract-plugin
module.exports = {"narrow":"style_narrow__rq4lu3hx9LHp3Mvp2aLyq"};